module.exports = __webpack_public_path__ + "img/1440.127a9b1b.jpg";